module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAhCAYAAABX5MJvAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADgSURBVHgB7ZaBCcIwEEV/SgfoBnYDHaGjuIE6gSvoBK0b6AaO4AhuoBucV7BQQqxJk2tayIMjJPxyryGBAIkZofQFIip42HFVCM+T66CUeg+mWKImWU56z8zgUUCWNSwkLpDlrC8oU4q3rOShRHgef8/DYuFd2yAmLHD8nvgaMegJUBQRg8C0IgMC04hYCMiKOAjIiIwQCCviIRBGJICAn0hAgXEi/MGWZNib+uU/PO5cTW/evjEquL81Gm1+hQ/8Fw25Yd0wgxwv26CkhDVJoiNJdOQO2fbKrRzyNySWyAdALNsXyqYuxwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/images/icon/top.png
// module id = tkoE
// module chunks = 1